import { Header } from "./Components/Header";
import { Hero } from "./Components/Hero";
import { Challenge } from "./Components/Challenge";
import { Solution } from "./Components/Solution";
import { Benefits } from "./Components/Benefits";
import { Operation } from "./Components/Operation";
import { Implementation } from "./Components/Implementation";
import { Contact } from "./Components/Contact";
import { Footer } from "./Components/Footer";


export const App = () => {
  return (
    <div
      className="
        text-center
        mx-auto
        max-w-[1920px]
        w-full
        pt-8
        lg:pt-12
        flex
        flex-col
        gap-10
        md:gap-12
        lg:gap-20
        overflow-hidden
      "
    >
      <Header />
      <Hero />
      <Challenge />
      <Solution />
      <Benefits />
      <Operation />
      <Implementation />
      <Contact />
      <Footer />
    </div>
  );
}